export default __webpack_public_path__ + "static/media/login-img-2.2f3da3c6.jpeg";